import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { OrderFormInputData } from '../../models/order-form.model';
import { ORDER_FORM_EVENTS } from './order-form-events.model';

@Service()
export class OrderFormProducerService {
	private readonly eventBus = inject(EventBusService);

	openOrderForm(data: OrderFormInputData): void {
		this.eventBus.dispatch(ORDER_FORM_EVENTS.OPEN, data);
	}

	updateOrderForm(data: OrderFormInputData): void {
		this.eventBus.dispatch(ORDER_FORM_EVENTS.UPDATE, data);
	}
}
